/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_Layouttitle1Inputs */

const ja_company_meta_layouttitle1 = /** @type {(inputs: Company_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Company Information`)
};

const en_company_meta_layouttitle1 = /** @type {(inputs: Company_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Company Information`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Company Information" |
*
* @param {Company_Meta_Layouttitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_meta_layouttitle1 = /** @type {((inputs?: Company_Meta_Layouttitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_Layouttitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_layouttitle1(inputs)
	return en_company_meta_layouttitle1(inputs)
});
export { company_meta_layouttitle1 as "company_meta_layoutTitle" }